/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BigCommercePickupDefaults
 */
export interface BigCommercePickupDefaults {
  /**
   *
   * @type {string}
   * @memberof BigCommercePickupDefaults
   */
  locationType: string;
  /**
   *
   * @type {string}
   * @memberof BigCommercePickupDefaults
   */
  distributionWarehouseBrand?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof BigCommercePickupDefaults
   */
  accessorials: Array<string>;
}

/**
 * Check if a given object implements the BigCommercePickupDefaults interface.
 */
export function instanceOfBigCommercePickupDefaults(
  value: object,
): value is BigCommercePickupDefaults {
  if (!("locationType" in value) || value["locationType"] === undefined)
    return false;
  if (!("accessorials" in value) || value["accessorials"] === undefined)
    return false;
  return true;
}

export function BigCommercePickupDefaultsFromJSON(
  json: any,
): BigCommercePickupDefaults {
  return BigCommercePickupDefaultsFromJSONTyped(json, false);
}

export function BigCommercePickupDefaultsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommercePickupDefaults {
  if (json == null) {
    return json;
  }
  return {
    locationType: json["locationType"],
    distributionWarehouseBrand:
      json["distributionWarehouseBrand"] == null
        ? undefined
        : json["distributionWarehouseBrand"],
    accessorials: json["accessorials"],
  };
}

export function BigCommercePickupDefaultsToJSON(
  json: any,
): BigCommercePickupDefaults {
  return BigCommercePickupDefaultsToJSONTyped(json, false);
}

export function BigCommercePickupDefaultsToJSONTyped(
  value?: BigCommercePickupDefaults | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    locationType: value["locationType"],
    distributionWarehouseBrand: value["distributionWarehouseBrand"],
    accessorials: value["accessorials"],
  };
}
